import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";

interface IProps {
  filter?: string;
}

export async function GetPaymentNotice({ filter }: IProps) {
  const url = `${endpoints.ADMFHIR}/PaymentNotice${filter ? `?${filter}` : ''}`;

  const headers = {
    Accept: "*/*",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .get(url, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`GetPaymentNotice: ${response.status}`);
      }
      return { data: response.data, status: response.status };
    })
    .catch((error) => {
      console.error("GetPaymentNotice", error);
      toast.error(`Erro ao buscar PaymentNotice: ${error?.response?.status}`);
      throw new Error();
    });
  
  if (response) return response;
} 